import { getCountries as i, getCountryRegions as a } from "../api/services/index.js";
import { restoreLocationPartFromCache as t, LocationPart as e, setCountries as c, setCurrentCountry as u, setCurrentCountryRegions as C, getLocation as m } from "./index.js";
import { createLocationProvider as y } from "@ado/location-library";
import { promiseAllCached as p } from "../../../libraries/index.js";
import { createKnownQueryParametersProvider as d } from "../../../libraries/known_query_parameters/index.js";
import { KnownQueryKey as g } from "../../../libraries/known_query_parameters/index3.js";
const f = async () => {
  t(e.Countries), t(e.CurrentCountry, n());
  const o = await i({});
  c(o.result);
  const s = y().provideLocation(
    o.result
  );
  u(s);
}, l = async () => {
  const r = n();
  t(e.CountryRegions, r);
  const o = await a(r);
  C(r, o.result);
};
async function K(r = [f, l]) {
  return await p(r), m();
}
const n = () => d().provideParameter(
  g.CountryCode
) ?? "";
export {
  K as getLocationAsync,
  f as loadCountries,
  l as loadRegions
};
//# sourceMappingURL=index2.js.map
